function unwrapHighlights(container) {
  container.querySelectorAll('.text-highlight-font-dynamic').forEach((highlight) => {
    const textNode = document.createTextNode(highlight.textContent || '');
    highlight.replaceWith(textNode);
  });

  container.normalize();
}

function highlightFirstMatch(container) {
  const searchText = container.dataset.highlightText?.trim();
  const highlightFont = container.dataset.highlightFont?.trim() || 'accent';
  const highlightColor = container.dataset.highlightColor?.trim();
  const highlightRotate = container.dataset.highlightRotate === 'true';

  if (!searchText) return;

  unwrapHighlights(container);

  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!(node instanceof Text)) return NodeFilter.FILTER_REJECT;
      if (!node.nodeValue?.trim()) return NodeFilter.FILTER_REJECT;
      if (node.parentElement?.closest('.text-highlight-font-dynamic')) return NodeFilter.FILTER_REJECT;

      return NodeFilter.FILTER_ACCEPT;
    },
  });

  let currentNode = walker.nextNode();

  while (currentNode) {
    const matchIndex = currentNode.nodeValue.indexOf(searchText);

    if (matchIndex !== -1) {
      const matchNode = currentNode.splitText(matchIndex);
      const afterNode = matchNode.splitText(searchText.length);
      const highlight = document.createElement('span');

      highlight.className = `text-highlight-font text-highlight-font--${highlightFont} text-highlight-font-dynamic${highlightRotate ? ' text-highlight-font--rotated' : ''}`;
      highlight.textContent = searchText;
      if (highlightColor) {
        highlight.style.color = highlightColor;
      }

      matchNode.parentNode?.replaceChild(highlight, matchNode);
      return;
    }

    currentNode = walker.nextNode();
  }
}

function applyTextHighlights(root = document) {
  const containers =
    root instanceof Element || root instanceof Document
      ? root.querySelectorAll('[data-highlight-text]')
      : document.querySelectorAll('[data-highlight-text]');

  containers.forEach((container) => {
    if (container instanceof HTMLElement) {
      highlightFirstMatch(container);
    }
  });
}

function scheduleApply(root) {
  requestAnimationFrame(() => applyTextHighlights(root));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => applyTextHighlights(document));
} else {
  applyTextHighlights(document);
}

document.addEventListener('shopify:section:load', (event) => {
  scheduleApply(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  scheduleApply(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  scheduleApply(event.target);
});
